/* 82ZONE brand system - runtime fixes that CSS cannot reach.
 * 1) Slider clones: demote duplicated <img> payloads to low priority so
 *    mobile stops competing with the LCP slide for bandwidth.
 * 2) Promote the first lookbook/department image to eager + high priority.
 * Theme-Editor safe: idempotent, rebinds on section load.
 */
(function () {
  function demoteCloneImages(container) {
    container.querySelectorAll('.slick-slide.slick-cloned img').forEach(function (img) {
      img.setAttribute('loading', 'lazy');
      img.setAttribute('fetchpriority', 'low');
    });
  }

  function promoteLeadImages(root) {
    var selectors = [
      '.zone-lookbook__media img',
      '.zone-lookbook img',
      '.department-split img',
      '[data-department-split] img'
    ];
    root.querySelectorAll(selectors.join(',')).forEach(function (img, i) {
      if (i < 2) {
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
      }
    });
  }

  function init(scope) {
    var root = scope || document;
    var slider = root.querySelector('.homepage_slider');
    if (slider) {
      if (slider.classList.contains('slick-initialized')) {
        demoteCloneImages(slider);
      } else {
        slider.addEventListener('init', function () { demoteCloneImages(slider); }, { once: true });
        window.setTimeout(function () { demoteCloneImages(slider); }, 800);
      }
    }
    promoteLeadImages(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
